import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    padding: 0 50px 50px 50px;
    background: #000;

    @media (max-width: 768px) {
        padding: 0 20px 50px 20px;
    }

    @media (max-width: 400px) {
        padding: 0 15px 50px 15px;
    }
`

export const Titulo = styled.span`
    float: left;
    width: 100%;
    padding: 0 15px;
    text-align: center;
    color: #F09C00;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 40px;
    line-height: 28px;

    strong {
        color: #fff;
    }

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 26px;
        margin-bottom: 25px;
    }
`

export const BoxRegua = styled.div`
    float: left;
    width: 100%;
    height: 45px;
    background: #fff;
    border-radius: 24px;
    overflow: hidden;
`

export const Valor = styled.div`
    float: left;
    width: ${props => props.porcentagem}%;
    height: 45px;
    background: linear-gradient(90deg, #EFEFEF 0%, #F09C00 100%);
    border-radius: 24px;
    position: relative;

    ::after {
        content: "";
        position: absolute;
        right: 10px;
        top: 10px;
        width: 25px;
        height: 25px;
        background-color: #fff;
        border-radius: 50px;
    }
`

export const ValorGasto = styled.span`
    position: absolute;
    right: 50px;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    top: calc(50% - 9px);
`

export const Gabarito = styled.ul`
    float: left;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 0;
    margin: 30px 0 0 0;

    @media (max-width: 768px) {
        gap: 5px;
    }
`

export const ItemGabarito = styled.li`
    border-radius: 8px;
    background: #2B2B2B;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 80px;
    padding: 0 5px;
`

export const RangeGabarito = styled.span`
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    line-height: 16px;

    @media (max-width: 768px) {
        font-size: 10px;
    }
`

export const ValorGabarito = styled.span`
    color: #F09C00;
    font-size: 22px;
    font-weight: 900;
    margin-top: 3px;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`
